import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography/Typography';

import { withStyles } from '@material-ui/core/styles';
import { COLORS, commonStyles } from '../styles/styles';
import { STATUSES } from '../constants';

import { MDBBadge, MDBContainer } from "mdbreact";

const getStatusName = status => {
  
  switch (status) {
    case STATUSES.notStarted.name:
      return STATUSES.notStarted.display;
    case STATUSES.completed.name:
      return STATUSES.completed.display;
    case STATUSES.inProgress.name:
      return STATUSES.inProgress.display;
    case STATUSES.extension_request.name:
      return STATUSES.extension_request.display;
    case STATUSES.resubmission_request.name:
      return STATUSES.resubmission_request.display;
    case STATUSES.ready.name:
      return STATUSES.ready.display;
    case STATUSES.locked.name:
      return STATUSES.locked.display;
    default:
      return COLORS.yellow;
  }
};

const getStatusClass = status => {
  switch (status) {
    case STATUSES.notStarted.name:
      return 'danger-color-dark';
  case STATUSES.completed.name:
      return 'success-color';
  case STATUSES.inProgress.name:
      return 'warning-color';
  case STATUSES.extension_request.name:
      return 'warning-color';
  case STATUSES.resubmission_request.name:
      return 'warning-color';
  case STATUSES.extension_request.name:
      return 'success-color';
  case STATUSES.locked.name:
    return 'danger-color';
  default:
    return 'warning-color';
  }
};

const CardStatus = ({ classes, status }) => (
  <MDBBadge pill color={getStatusClass(status)} className='text-white'>{getStatusName(status)}</MDBBadge>
);

CardStatus.propTypes = {
  classes: PropTypes.instanceOf(Object),
  status: PropTypes.string,
};

const styles = theme => ({
  ...commonStyles,
  headerHolder:{
    position:'absolute', 
    right:2, 
    top:92,
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    float:'right'
  },
  status: {
    color: '#fff',
    display: 'flex',
    fontSize: theme.typography.fontSize - 4,
    textTransform: 'uppercase',
    fontWeight: theme.typography.fontWeightLight,
    borderRadius:4,
    padding: '4px 10px',
  },
});

export default compose(withStyles(styles))(CardStatus);



// WEBPACK FOOTER //
// ./src/Components/CardStatus.jsx